export default {
    csManagement: {
        page: {
            title: 'CS管理センター',
            description: 'テナントクォータ、ドキュメント総量、Token消費の管理',
        },
        quota: {
            searchPlaceholder: 'テナントIDで検索',
            typePlaceholder: 'クォータタイプ',
            search: '検索',
            create: 'クォータ追加',
            tenantId: 'テナントID',
            quotaType: 'クォータタイプ',
            typeDocument: 'ドキュメント総量',
            typeToken: 'Token消費総量',
            quotaLimit: '上限',
            quotaUsed: '使用済み',
            contractPeriod: '契約期間',
            contractStart: '契約開始',
            contractEnd: '契約終了',
            status: 'ステータス',
            statusActive: '有効',
            statusExpired: '期限切れ',
            remark: '備考',
            action: '操作',
            edit: '編集',
            delete: '削除',
            createTitle: 'クォータ追加',
            editTitle: 'クォータ編集',
            cancel: 'キャンセル',
            confirm: '確認',
        },
    },
}
